import i18n from '@/i18n'

export function getTranslationOrUndefined (key) {
    if (i18n.te(key)) {
        const translated = i18n.t(key)

        if (translated && translated !== 'null') {
            return translated
        } else {
            return undefined
        }
    } else {
        return undefined
    }
}
